import ItemTypeBaseController from '../common/item_type.base.controller';
import AppConstants from '../../../config/app.constants';

class ItemTypeEditController extends ItemTypeBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams, $scope) {
        super(Auth, $state, User, ItemTypeService, Modal, $translate, $stateParams)

        this.ItemTypeService = ItemTypeService;
        this.$scope = $scope;
        this.user = User;
        this.hasACL = {};
        this.defaultModel = {
            label: null,
            loading: false,
        }
        this.model = angular.copy(this.defaultModel);
    }

    $onInit() {
        this.Service.get(this.$stateParams.id)
            .then((data) => {
                this.defaultModel = data.results;
                this.rawId = data.results.id;
                this.model.id = data.results.id;
                this.model.label = data.results.label;
            })
            .catch((err) => {
                console.log(err);
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel)
        this.clearErrors();
    }

    update() {
        this.model.isUpdating = true;
        delete this.model.errorMessage;

        this.Service.update(this.$stateParams.id, {
            label: this.model.label,
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }

}

export default ItemTypeEditController;


// WEBPACK FOOTER //
// ./client/app/components/item_type/edit/item_type.edit.controller.js